export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const darkPageBg = '#3A3444';
  const darkBorder = '#2E2A36';
  const lightBorder = '#ECE8F3';
  const lightPageBg = '#FFFFFF';

  return {
    containerWrapper: {
      height: '100%',
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'start',
      minHeight: 0,
      overflow: 'hidden',
      fontFamily: theme.typography.fontFamily,
    },
    pageWrapper: {
      flex: '1',
      minHeight: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: theme.typography.fontFamily,
    },
    buttonWrapper: {
      flexShrink: 0,
      m: { xs: '1rem 1rem 1rem 0.5rem', sm: '1.5rem 1.5rem 1.5rem 0.5rem' },
    },
    leftWrapper: {
      height: '100%',
      maxHeight: '100%',
      width: { md: '360px' },
      backgroundColor: isDark ? darkPageBg : lightPageBg,
      borderTop: `1px solid ${isDark ? darkBorder : lightBorder}`,
      borderRight: `1px solid ${isDark ? darkBorder : lightBorder}`,
      borderBottom: 0,
      borderLeft: 0,
    },
    pageContent: {
      flex: '1',
      minHeight: 0,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
    assignmentDetailsWrapper: {
      flex: '1',
      minHeight: 0,
      height: '100%',
      width: '100%',
      overflow: 'auto',
    },
    assignments: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
      minHeight: 0,
      height: '100%',
      width: '100%',
    },
    assignmentDetailsMobile: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      px: { xs: '1rem', sm: '1.5rem' },
      pb: { xs: '1rem', sm: '1.5rem' },
      borderRadius: '8px',
    },
    // assignmentDetailsWrapper: {
    //   flex: '1',
    //   height: '100%',
    //   width: '100%',
    // },
    // assignments: {
    //   display: 'flex',
    //   flexDirection: 'column',
    //   flex: '1',
    //   height: '100%',
    //   width: '100%',
    // },
  };
};
